import * as type from '../types';
import { commonNotificationsRoute, rodoAcceptRoute } from '../../config/routes';
import { get, patch, post } from '../../config/Requests';
import { setRodo } from '../../config/sessionData';

export const startLoader = (dispatch) => {
    dispatch({
        type: type.REQUEST_LOADER,
        value: false
    });
};

export const startLoader2 = () => {
    return {
        type: type.REQUEST_LOADER,
        value: false
    };
};

export const stopLoader = (dispatch) => {
    dispatch({
        type: type.REQUEST_LOADER,
        value: true
    });
};

export const stopLoader2 = () => {
    return {
        type: type.REQUEST_LOADER,
        value: true
    };
};

export const closeSnackbar = () => {
    return {
        type: type.CLOSE_SNACKBAR
    };
};

export const changeTheme = () => {
    return {
        type: type.CHANGE_THEME
    };
};

export const changeDrawer = () => {
    return {
        type: type.CHANGE_DRAWER
    };
};

export const closeDrawer = () => {
    return {
        type: type.ClOSE_DRAWER
    };
};

export const openSnackbarWarning = (dispatch, message) => {
    dispatch({
        type: type.OPEN_SNACKBAR,
        value: message,
        snackType: "warning"
    });
};

export const notifyError = (message) => {
    return dispatch => {
        openSnackbarError(dispatch, message);
    };
};

export const openSnackbarError = (dispatch, message) => {
    dispatch({
        type: type.OPEN_SNACKBAR,
        value: message,
        snackType: "danger"
    });
};

export const openSnackbarInfo = (message) => {
    return dispatch => {
        dispatch({
            type: type.OPEN_SNACKBAR,
            value: message,
            snackType: "info"
        });
    };
};

export const openSnackbarInfoDispatch = (dispatch, message) => {
    dispatch({
        type: type.OPEN_SNACKBAR,
        value: message,
        snackType: "info"
    });
};

export const changeWelcomeDialogState = (value) => {
    return dispatch => {
        dispatch({
            type: type.CLOSE_WELCOME_DIALOG,
            value: value
        });
    };
};

export const getFirstWelcomeNotification = (dispatch) => {
    // startLoader(dispatch);
    getNotifications(dispatch);
};

export const fetchNotifications = () => {
    return dispatch => {
        getNotifications(dispatch);
    };
};

const getNotifications = async (dispatch) => {
    get(
        dispatch,
        commonNotificationsRoute,
        { },
        response => {
            dispatch({
                type: type.SET_NOTIFICATIONS,
                value: response.data
            });
        }
    );
};

export const readNotification = (id) => {
    return dispatch => {
        patch(
            dispatch,
            commonNotificationsRoute,
            { powiadomienia_id: id },
            { przeczytano: true },
            () => {
                dispatch({
                    type: type.SET_NOTIFICATION_READ,
                    value: id
                });
            }
        );
    };
};

export const changeCookieAcceptation = value => {
    return dispatch => {
        dispatch({
            type: type.SET_COOKIES_ACCEPTED,
            value: value
        });
    };
};

export const rodoAccept = () => {
    return dispatch => {
        post(
            dispatch,
            rodoAcceptRoute,
            {rodo: true},
            response => {
                dispatch(changeRodoAcceptation(response.data.rodo));
            }
        )
    };
};

export const changeRodoAcceptation = (status) => {
    setRodo(status);
    return {
        type: type.SET_RODO_ACCEPTED,
        value: status
    };
};
